import classnames from "classnames";

import styles from "./CustomerCard.module.scss";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

const CustomerCard = ({ className, customer, orderNumber, linkToOrder, condition }) => {
  const ref = useRef();
  const { name, mc } = customer || {};
  const [fullName, setFullName] = useState(false);
  const [width, setWidth] = useState({ max: 0, current: 0 });
  const nameCondition = width.max <= width.current;

  useEffect(() => {
    const MAX_WIDTH = ref.current.parentElement.clientWidth;
    const ELEMENT_WIDTH = ref.current.clientWidth;

    setWidth({ max: MAX_WIDTH, current: ELEMENT_WIDTH });

    const listener = (event) => {
      const el = ref?.current;
      if (!el || el.contains(event?.target || null)) {
        return;
      }

      setFullName(false);
    };

    document.addEventListener("mouseenter", listener);

    return () => {
      document.removeEventListener("mouseenter", listener);
    };
  }, [ref, customer]);

  return (
    <div
      className={classnames(styles.wrapper, className)}
      style={{ minHeight: condition ? "7.9rem" : "6.5rem" }}
    >
      <div
        className={styles.group}
        style={{ overflow: "hidden", marginRight: condition ? "" : "1.8rem" }}
      >
        <span className={styles.title}>Company Name:</span>
        <span
          className={classnames(
            styles.name,
            styles.value,
            nameCondition ? styles.shortName : "",
          )}
          onMouseEnter={() => (nameCondition ? setFullName(true) : {})}
          onMouseLeave={() => (nameCondition ? setFullName(false) : {})}
          ref={ref}
        >
          {name}
          {fullName && nameCondition && <div className={styles.fullName}>{name}</div>}
        </span>
      </div>
      <div className={styles.group}>
        <span className={styles.title}>MC Number:</span>
        <span className={styles.value}>{mc}</span>
      </div>
      <div className={styles.group}>
        <span className={styles.title}>Order Number:</span>
        {linkToOrder ? (
          <Link
            to={linkToOrder}
            style={{ textDecoration: "underline" }}
            className={styles.value}
            target="_blank"
          >
            {orderNumber}
          </Link>
        ) : (
          <span className={styles.value}>{orderNumber}</span>
        )}
      </div>
    </div>
  );
};

export default CustomerCard;
